function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import capitalize from "lodash/capitalize";
var variantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  body1: "p",
  body2: "p"
};
var variants = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "body1", "body2"];
var defaultVariant = "body1";

var fontFamily = function fontFamily(_ref) {
  var theme = _ref.theme,
      font = _ref.font,
      variant = _ref.variant;
  return theme.typography[variant]["fontFamily".concat(capitalize(font))];
};

var textAlign = function textAlign(_ref2) {
  var align = _ref2.align;
  return align !== "inherit" && "text-align: " + align + ";";
};

var StyledTypography = styled(variantMapping[defaultVariant]).withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "sc-1w88vqb-0"
})(["", " ", " font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], function (_ref3) {
  var gutterBottom = _ref3.gutterBottom;
  return gutterBottom && "margin-bottom: 0.35em;";
}, textAlign, fontFamily, function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.typography[variant].fontWeight;
}, function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return theme.typography[variant].fontSize;
}, function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return theme.typography[variant].lineHeight;
});

function Typography(_ref7) {
  var _ref7$variant = _ref7.variant,
      variant = _ref7$variant === void 0 ? defaultVariant : _ref7$variant,
      _ref7$component = _ref7.component,
      component = _ref7$component === void 0 ? variantMapping[variant] : _ref7$component,
      _ref7$font = _ref7.font,
      font = _ref7$font === void 0 ? "primary" : _ref7$font,
      _ref7$gutterBottom = _ref7.gutterBottom,
      gutterBottom = _ref7$gutterBottom === void 0 ? false : _ref7$gutterBottom,
      _ref7$align = _ref7.align,
      align = _ref7$align === void 0 ? "inherit" : _ref7$align,
      rest = _objectWithoutProperties(_ref7, ["variant", "component", "font", "gutterBottom", "align"]);

  return React.createElement(StyledTypography, _extends({
    as: component,
    font: font,
    variant: variant,
    gutterBottom: gutterBottom,
    align: align
  }, rest));
}

Typography.propTypes = {
  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(variants),
  font: PropTypes.oneOf(["primary", "secondary"]),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.elementType,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(["inherit", "left", "center", "right", "justify"])
};
export default Typography;